module.exports = __webpack_public_path__ + "img/treasure.4618373c.png";